'use client'

import { useRef, type ReactNode } from 'react'
import { initAnalytics, track } from '@/lib/analytics'

/**
 * Funnel `booking_start` for the native booking forms, on the /bookings/[slug]
 * page and in the booking_widget section. Without it a store that books
 * natively recorded 0 starts against real bookings (AE: 64 bookings, 0 starts
 * over 90 days, 2026-11-03), so its funnel booking rate read zero.
 *
 * WHY first interaction, not mount: the widget sits on marketing pages (the AE
 * homepage), so a mount emit would count every homepage view as a start. The
 * first pointer/key/focus inside the form is the same "started" moment
 * FormRender uses for form_start, and is comparable to a FareHarbor tenant's
 * deliberate button click. Once per mount; consent-gated through `track`.
 */
export function BookingStartTracker({ slug, mode, children }: { slug: string; mode: 'session' | 'daily'; children: ReactNode }) {
  const started = useRef(false)
  function start() {
    if (started.current) return
    started.current = true
    // A direct load can reach here before AnalyticsScripts' init; this also
    // registers flush-on-hide. Idempotent.
    initAnalytics()
    track('booking_start', { slug, mode })
  }
  return (
    // `contents`: no box of its own, so the form lays out exactly as before.
    <div className="contents" onPointerDownCapture={start} onKeyDownCapture={start} onFocusCapture={start}>
      {children}
    </div>
  )
}
